import { useState } from 'react';
import Select, { CSSObjectWithLabel } from 'react-select';

import SelectAll from './Icons/SelectAll';

export interface MultiSelectOption {
    value: string,
    label: string,
};

type MultiSelectProps = {
    onChange?: (selectedOptions: MultiSelectOption[]) => void,
    dataName: string,
    title?: string,
    value?: string,
    visible?: boolean,
    readonly?: boolean,
    required?: boolean,
    options: MultiSelectOption[],
    defaultOptions?: MultiSelectOption[],
    specialOptionsTitle?: string,
    specialOptions?: MultiSelectOption[],
    error?: boolean,
    errorMessage?: string,
};

const MultiSelectField = ({
    onChange = () => {},
    dataName,
    value = '',
    title = '',
    visible = true,
    readonly = false,
    required = false,
    options,
    specialOptionsTitle = '',
    specialOptions = [],
    error = false,
    errorMessage = '',
}: MultiSelectProps) => {

    const [values, setVaules] = useState<MultiSelectOption[]>(value !== '' ? value.split(', ').map(x => ({ label: x, value: x})) : []);
    const [myKey, setMyKey] = useState<string>(`multiSelect_${Date.now()}`);

    const dangerRed = '#dc3545';
    const blattnerBlue = '#1967d2';
    const lightGray = '#FAFAFA';

    const handleAddClosureStatus = (selectedOptions: MultiSelectOption[]) => {
        if (onChange) {
            onChange(selectedOptions);
        }
        setVaules(selectedOptions)
        value = selectedOptions.map(x => x.value).join(', ')
    }

    const handleSelectSpecial = () => {
        setVaules(specialOptions);
        handleAddClosureStatus(specialOptions);
        setMyKey(`multiSelect_${Date.now()}`);
    }

    const renderSpecialButton = () => {
        if (specialOptions.length > 0 && !readonly) {
            return (
                <label
                    onClick={() => handleSelectSpecial()}
                    title={specialOptionsTitle}
                >
                    &nbsp;<SelectAll />
                </label>
            );
        }
        return (<></>);
    }

    const renderRequired = () => {
        if (required) {
            return (
                <b>
                    <label className='required'>
                        &nbsp;*
                    </label>
                </b>
            );
        }
        return (<></>);
    }

    return (
        visible ?
        <div
            className={`${error ? 'bg-danger rounded border border-3 border-danger' : ''}`}
            title={`${error ? errorMessage : ''}`}
        >
            <div className={'pb-2'}>
                <b><label className={`${error ? 'text-white' : ''}`} htmlFor={dataName + title}>{title}</label></b>
                {renderRequired()}
                {renderSpecialButton()}
            </div>
            <Select
                styles={{
                    multiValue: (base) => ({
                        ...base,
                        backgroundColor: lightGray,
                    } as CSSObjectWithLabel),
                    option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected ? '#e8f3ff' : 'white',
                        color: state.isSelected ? blattnerBlue : 'inherit',
                        ':hover': {
                            backgroundColor: error ? dangerRed : blattnerBlue,
                            color: 'white'
                        },
                    } as CSSObjectWithLabel)
                }}
                id={dataName + title}
                name={dataName}
                key={myKey}
                value={values}
                options={options}
                isMulti
                isClearable
                isSearchable
                isDisabled={readonly}
                closeMenuOnSelect={false}
                onChange={(e: any) => handleAddClosureStatus(e)}
            />
        </div>
        : <></> // If not visible, return empty element instead of null
    );
};

export default MultiSelectField;
